<template>
  <div>
    <Button type="primary" @click="openMaterialSelectionDrawer()">管理材料</Button>
    <Row :gutter="12">
      <Col span="8">
        <div class="handle-wrapper">
          <h2>产品</h2>
        </div>
        <Table
          style="margin-bottom: 15px"
          :loading="materialLoading"
          :columns="materialColumns"
          :data="filteredSacMaterialList('product')"
        ></Table>
      </Col>
      <Col span="8">
        <div class="handle-wrapper">
          <h2>母液</h2>
        </div>
        <Table
          class="table"
          :loading="materialLoading"
          :columns="materialColumns"
          :data="filteredSacMaterialList('semi')"
        ></Table>
      </Col>
      <Col span="8">
        <div class="handle-wrapper">
          <h2>复配小料</h2>
        </div>
        <Table
          class="table"
          :loading="materialLoading"
          :columns="materialColumns"
          :data="filteredSacMaterialList('raw')"
        ></Table>
      </Col>
    </Row>
    <!-- <EditSACDrawer ref="EditSACDrawer"/> -->
    <Modal v-model="materialSelectionModal" width="600">
      <p slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>选择材料</span>
      </p>
      <div>
        <CheckboxGroup v-model="selectedMaterials">
          <h3>成品</h3>
          <Checkbox
            v-for="e in filteredFullMaterialList('product')"
            :label="e._id"
            :key="e._id"
            size="large"
          >{{e.name}}{{e.model}}</Checkbox>
          <h3>母液</h3>
          <Checkbox
            v-for="e in filteredFullMaterialList('semi')"
            :label="e._id"
            :key="e._id"
            size="large"
          >{{e.name}}{{e.model}}</Checkbox>
          <h3>复配小料</h3>
          <Checkbox
            v-for="e in filteredFullMaterialList('raw')"
            :label="e._id"
            :key="e._id"
            size="large"
          >{{e.name}}{{e.model}}</Checkbox>
        </CheckboxGroup>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" :loading="saveMaterialLoading" @click="saveMaterial">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import EditSACDrawer from "./EditSACDrawer.vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "SACDetail_Material",
  components: { EditSACDrawer },
  props: ["sac"],
  data() {
    return {
      page: 0,
      searchText: "",
      materialSelectionModal: false,
      materialLoading: false,
      materialColumns: [
        {
          title: "名字",
          key: "name",
          minWidth: 150,
        },
        {
          title: "型号",
          key: "model",
          width: 100,
        },
      ],
      fullMaterialList: [],
      selectedMaterials: [],
      saveMaterialLoading: false,
      materialTableData: [],
      columns: [
        {
          title: "ID",
          key: "NoId",
          width: 100,
          render: (h, params) => h("span", params.row.NoId),
        },
        {
          title: "名字",
          key: "name",
          // width: 130,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditSACDrawer.openDrawer(params.row);
                    },
                  },
                },
                "SAC"
              ),
            ]);
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.sac.sacs,
      totalRows: (state) => state.sac.totalCounts,
    }),
    filteredFullMaterialList: function () {
      return (type) => this.fullMaterialList.filter((e) => e.type === type);
    },
    filteredSacMaterialList: function () {
      return (type) => {
        const sacMaterialList = this.sac.material;
        if (sacMaterialList && sacMaterialList.length === 0) return [];
        if (!type) return sacMaterialList;
        return sacMaterialList.filter((e) => e.type === type);
      };
    },
  },
  methods: {
    ...mapActions({
      getMaterials: "material/getMaterialsAction",
      updateSac: "sac/updateSacAction",
    }),
    async loadSacDetail() {},
    async saveMaterial() {
      try {
        this.saveMaterialLoading = true;
        const newSac = await this.updateSac({
          id: this.sac._id,
          data: { material: this.selectedMaterials },
        });
        this.$emit("updateSacFromComponent", newSac);
        this.saveMaterialLoading = false;
        this.materialSelectionModal = false;
        this.$Message.success(`成功`);
      } catch (error) {
        this.saveMaterialLoading = false;
        this.$Message.error(`失败: ${error}`);
      }
    },
    async loadMaterial() {
      try {
        this.fullMaterialList = await this.getMaterials({});
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    },
    openMaterialSelectionDrawer() {
      this.materialSelectionModal = true;
      this.selectedMaterials = this.filteredSacMaterialList().map((e) => e._id);
    },
  },
  created() {
    this.loadMaterial();
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)
  display flex

.m-area
  width 500px
  padding 0 12px

.c-area
  width 400px
  padding 0 12px

.table
  margin-bottom 15px
</style>
